import './Hero.css';

const CHAT_MESSAGES = [
  { from: 'user', text: 'What is my leave balance?' },
  { from: 'bot',  text: 'You have 12 days of earned leave, 3 sick leave days, and 2 optional holidays remaining for 2026.' },
  { from: 'user', text: 'Can you raise an IT ticket for VPN access?' },
  { from: 'bot',  text: 'Done! I\'ve raised ticket IT-2026-0045 for VPN access with Medium priority. Your IT team will respond within 2 hours per your SLA.' },
  { from: 'user', text: 'Show me Q2 sales summary' },
  { from: 'bot',  text: '📊 Q2 FY2026: ₹4.2Cr revenue (↑18% QoQ), 142 new deals closed, top region: West India. Full report emailed to you.' },
];

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero__bg-glow" />
      <div className="hero__grid-lines" />

      <div className="hero__left">
        <div className="badge rise delay-1">
          <span className="pulse-dot" />
          Conversational AI · Built for Business
        </div>

        <p className="hero__eyebrow rise delay-2">Aiprus Software</p>

        <h1 className="hero__h1 rise delay-3">
          Domain-Specific<br />
          <span className="hero__gradient">AI Agents</span><br />
          for Every Team.
        </h1>

        <p className="hero__sub rise delay-4">
          Generic bots fail because they only answer static FAQs. Aiprus builds
          domain-specific agents that understand business context, retrieve trusted
          knowledge, connect to live systems, and complete approved actions inside
          the conversation.
        </p>

        <div className="hero__chips rise delay-5">
          {['Best for repetitive queries', 'RAG & live data', 'Web, Teams, WhatsApp', 'Action-capable'].map(c => (
            <span key={c} className="hero__chip">{c}</span>
          ))}
        </div>

        <div className="hero__actions rise delay-6">
          <a href="#bots" className="btn-primary">Explore our bots</a>
          <a href="#contact" className="btn-outline">Talk to an expert →</a>
        </div>
      </div>

      <div className="hero__right rise delay-7">
        <div className="chat-window">
          <div className="chat-window__header">
            <div className="chat-header-dot active" />
            <div className="chat-header-info">
              <span className="chat-header-name">Aiva AI Agent</span>
              <span className="chat-header-status">● Online · Answering instantly</span>
            </div>
            <div className="chat-header-badge">HR · IT · Sales</div>
          </div>
          <div className="chat-window__body">
            {CHAT_MESSAGES.map((msg, i) => (
              <div key={i} className={`chat-msg chat-msg--${msg.from}`}>
                {msg.from === 'bot' && (
                  <div className="chat-avatar">AI</div>
                )}
                <div className="chat-bubble">{msg.text}</div>
              </div>
            ))}
          </div>
          <div className="chat-window__footer">
            <div className="chat-input">
              <span>Ask me anything…</span>
              <button className="chat-send">↑</button>
            </div>
          </div>
        </div>

        <div className="hero__floating-card hero__floating-card--1">
          <span className="fc-icon">⚡</span>
          <div>
            <div className="fc-label">Avg response</div>
            <div className="fc-val">&lt;1.2s</div>
          </div>
        </div>
        <div className="hero__floating-card hero__floating-card--2">
          <span className="fc-icon">✅</span>
          <div>
            <div className="fc-label">Resolution rate</div>
            <div className="fc-val">80%+</div>
          </div>
        </div>
      </div>
    </section>
  );
}
